<template>
  <div class="qr-code-card">
    <div class="entry">
      <div class="bar" @click="toggleDetails()">
        <span class="toggle">
          <font-awesome-icon icon="caret-down" v-if="showDetails"></font-awesome-icon>
          <font-awesome-icon icon="caret-right" v-else></font-awesome-icon>
        </span>
        <span class="title">
          {{cardOriginalCategory}} 
          {{cardOriginalNumber}}</span>
        <span class="title-extended">{{cardOriginalTitle}}</span>
      </div>
      <div class="btn-bar btn-bar-top" v-if="editMode && showDetails">
          <button class="btn-save">
            <font-awesome-icon icon="save"></font-awesome-icon>
            <span>Speichern</span>
          </button>
          <button class="btn-cancel" @click="exitEditMode()">
            <font-awesome-icon icon="times"></font-awesome-icon>
            <span>Abbrechen</span>
          </button>
        </div>
      <div class="show-details" v-if="showDetails">
        <div class="qr-code">
          <vue-qrcode :value="cardURL" 
            errorCorrectionLevel="H" 
            :color="{ dark: '#000000ff', light: '#fafafaff' }"/>
            <p class="qr-title">{{cardOriginalCategory}} {{cardOriginalNumber}}</p>
        </div>
        <div class="details">
          <div class="detail-entry">
            <div class="first-row">
              <div>
                <h4>Gerät</h4>
                <p v-if="!editMode">{{cardTitle}}</p>
                <input v-else type="text" v-model="cardTitle">
              </div>
              <div>
                <h4>Kategorie</h4>
                <p v-if="!editMode">{{cardCategory}}</p>
                <input v-else type="text" v-model="cardCategory">
              </div>
              <div>
                <h4>Number</h4>
                <p v-if="!editMode">{{cardNumber}}</p>
                <input v-else type="text" v-model="cardNumber">
              </div>
            </div>
          </div>
          <div class="detail-entry">
            <h4>URL</h4>
            <p v-if="!editMode">{{cardURL}}</p>
            <input v-else type="text" v-model="cardURL">
          </div>
          <div class="detail-entry">
            <h4>Notizen</h4>
            <div v-if="!editMode">
              <p v-if="cardDescription">{{cardDescription}}</p>
              <p v-else>Keine Beschreibung vorhanden.</p>
            </div>
            
            <textarea v-else v-model="cardDescription"></textarea>
          </div>
        </div>
        <div></div><div></div>
        <div>
          <div class="btn-bar" v-if="!editMode">
            <button class="btn-print">
              <font-awesome-icon icon="print"></font-awesome-icon>
              <span>Drucken</span>
            </button>
            <button class="btn-edit"  @click="editMode = true">
              <font-awesome-icon icon="cog"></font-awesome-icon>
              <span>Bearbeiten</span>
            </button>
            <button class="btn-delete" @click="removeShow()">
              <font-awesome-icon icon="trash"></font-awesome-icon>
              <span>Löschen</span>
            </button>
          </div>
        </div>
      </div>
    </div>

    <modal :name="'delete-modal-' + cardId" :pivotY=0.2 height="auto" :adaptive="true">
      <div class="delete-modal modal">
        <h1>Wirklich Löschen?</h1>
        <p>
          Sind Sie sicher das sie den QR-Code wirklich löschen wollen. <br>
          Gelöschte QR-Codes kommen nicht wiederhergestellt werden.           
        </p>
        <div class="footer">
          <button class="btn-primary" @click="removeSubmit()">
            <font-awesome-icon icon="trash"/>
            Löschen</button>
          <button class="btn-default" @click="removeHide()">Abbrechen</button>
        </div>
      </div>
    </modal>

    

  </div>
</template>

<script>
import VueQrcode from 'vue-qrcode'


export default {
  name: 'QRCodeCard',
  components: {
    VueQrcode,
  },
  data() {
    return {
      showDetails: false,
      editMode: false,
      cardTitle: "Not loaded",
      cardCategory: "ERR",
      cardNumber: "---",
      cardURL: "Error loading, please try again later.",
      cardDescription: "",
      cardOriginalCategory: "Not loaded",
      cardOriginalDescription: "Not loaded",
      cardOriginalNumber: "Not loaded",
      cardOriginalTitle: "Not loaded",
      cardOriginalURL: "Not loaded",
      cardId: -1
    }
  },
  methods: {
    toggleDetails() {
      this.showDetails = !this.showDetails
    },
    exitEditMode() {
      this.editMode = false
      // TODO: reset all values
    },
    destroy() {

    },
    removeShow() {
      this.$modal.show('delete-modal-' + this.cardId)
    },
    removeHide() {
      this.$modal.hide('delete-modal-' + this.cardId)
    },
    removeSubmit() {
      this.axios.post('http://localhost:8000/api/v1/qr/delete', {
          qrID: this.cardId}, {withCredentials: true})
      .then(() => {
        this.$destroy();
        this.$el.parentNode.removeChild(this.$el)
        
        this.$modal.hide('delete-modal-' + this.cardId)
      })
    }
  },
  props: {
    category: String,
    description: String, 
    number: String,
    title: String,
    url: String,
    id: Number
  },
  mounted() {
    this.cardCategory = this.$props.category
    this.cardDescription = this.$props.description
    this.cardNumber = this.$props.number
    this.cardTitle = this.$props.title
    this.cardURL = this.$props.url

    this.cardOriginalCategory = this.$props.category
    this.cardOriginalDescription = this.$props.description
    this.cardOriginalNumber = this.$props.number
    this.cardOriginalTitle = this.$props.title
    this.cardOriginalURL = this.$props.url

    this.cardId = this.$props.id
  }
}
</script>

<style lang="scss" scoped>
@import "../styles/theme.scss";

.bar {
  background: white;
  border: 1px solid rgba(#b3b3b3, 0.6);
  box-shadow: $shadow-light;
  padding: 8px 20px;
  cursor: pointer;
  position: relative;

  .toggle {
    position: absolute;
  }

  .title {
    margin-left: 20px;
    font-weight: bold;
    position: absolute;
  }

  .title-extended {
    margin-left: 100px;
  }

}

.first-row {
    display: grid;
    grid-template-columns: 3fr 1fr 1fr;
  }

.show-details {
  padding-top: 20px;
  width: 100%;
  background: #fafafa;
  border-left: 1px solid rgba(#b3b3b3, 0.6);
  border-right: 1px solid rgba(#b3b3b3, 0.6);

  display: grid;
  grid-template-columns: 5fr 12fr 2fr;

  .detail-entry {
    margin: 15px 0px 15px 0px;

    h4, p {
      margin: 2px 0px;
    }
    p {
      font-size: 14px;
      line-height: 20px;
      margin-top: 5px;
    }
  }

  .qr-code {
    justify-self: center;
    align-self: center;

    img {
      width: 160px;
    }
  }

  input, textarea {
    width: 90%;
    border: none;
    background: #fafafa;
    outline: none;
    border-bottom: 2px solid $primary;
    font-size: 14px;
  }

  textarea {
    border: 2px solid $primary;
  }
}

.btn-bar {
  display: flex;
  justify-content: flex-end;
  margin: 16px 0px;

  button {
    border: none;
    outline: none;
    background: #fafafa;
    color: rgba($dark, 0.8);
    font-size: 16px;
    margin-left: 10px;
    cursor: pointer;

    svg {
      margin-right: 5px;
    }

    &:hover {
      color: $dark-0;
    }
  }

  .btn-delete {

    margin-left: 60px;
    &:hover {
      color: $primary;
    }
  }
}

.btn-bar-top {
  justify-content: flex-start;
  background: #fafafa;
  margin: 0px 0px;
  padding: 20px 30px 0px 30px;
  border-left: 1px solid rgba(#b3b3b3, 0.6);
  border-right: 1px solid rgba(#b3b3b3, 0.6);

  .btn-save {
    &:hover {
      color: green;
    }
  }
}

.qr-title {
  text-align: center;
  margin-top: -10px;
  font-weight: bold;
}


.modal {
  padding: 10px 30px;

  h1 {
    color: $primary;

    .number {
      font-size: 22px;
      opacity: 0.7;
    }
  }

  p {
    color: lighten($dark, 40);
    font-size: 14px;
  }

  .flex-row {
    display: flex;
    flex-direction: row;
    align-content: space-between;
    flex-wrap: wrap;

    .col-6 {
      width: 100%;

      @include tablet {
        width: 48%;
        margin: 0px 1%;
      }
    }
  }

  .footer {
    margin: 60px 0px 20px 0;
    display: flex;
    flex-direction: row-reverse;

    button  {
      font-size: 18px;
      font-weight: bold;
      margin-left: 12px;
    }
    .btn-default {
      color: lighten($dark, 40);

      &:hover {
        color: $dark;
      }
    }
    .btn-primary {
      color: desaturate($primary, 40);

      &:hover {
        color: $primary;
      }
    }
  }
}



</style>